// components/layout/NotificationDropdown.tsx
"use client";

import {
  Bell,
  ShoppingCart,
  Tag,
  Package,
  CheckCheck,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const MOCK_NOTIFICATIONS = [
  {
    id: 1,
    title: "سفارش جدید ثبت شد",
    description: "سفارش KH-1403-45830 توسط سارا احمدی",
    time: "۳۰ دقیقه پیش",
    icon: ShoppingCart,
    color: "text-blue-600 dark:text-blue-400",
    bgColor: "bg-blue-100 dark:bg-blue-500/20",
    isRead: false,
  },
  {
    id: 2,
    title: "تخفیف جدید اعمال شد",
    description: "کد تخفیف SUMMER20 فعال شد",
    time: "۲ ساعت پیش",
    icon: Tag,
    color: "text-orange-600 dark:text-orange-400",
    bgColor: "bg-orange-100 dark:bg-orange-500/20",
    isRead: false,
  },
  {
    id: 3,
    title: "موجودی محصول کم شد",
    description: "پودر قهوه کلاسنو کمتر از ۵ عدد",
    time: "۵ ساعت پیش",
    icon: Package,
    color: "text-red-600 dark:text-red-400",
    bgColor: "bg-red-100 dark:bg-red-500/20",
    isRead: false,
  },
];

export function NotificationDropdown() {
  const unreadCount = MOCK_NOTIFICATIONS.filter((n) => !n.isRead).length;

  return (
    <Popover>
      <PopoverTrigger
        className={cn(
          "relative inline-flex items-center justify-center h-9 w-9 rounded-lg",
          "text-muted-foreground hover:text-foreground hover:bg-brand-50/60 transition-colors",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30"
        )}
        aria-label="اعلان‌ها"
      >
        <Bell className="h-5 w-5" />
        {unreadCount > 0 && (
          <span className="absolute top-2 right-2 w-2.5 h-2.5 rounded-full bg-destructive ring-2 ring-background" />
        )}
      </PopoverTrigger>

      <PopoverContent
        align="end"
        className="w-80 p-0 bg-card border border-border/60 shadow-[0_12px_32px_-8px_rgba(8,60,32,0.15)] rounded-xl z-50 overflow-hidden"
        sideOffset={8}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-border/60 bg-primary/5">
          <div className="flex items-center gap-2">
            <h3 className="text-sm font-bold text-foreground">اعلان‌ها</h3>
            {unreadCount > 0 && (
              <span className="bg-primary/10 text-primary text-[10px] font-bold px-2 py-0.5 rounded-md">
                {unreadCount} جدید
              </span>
            )}
          </div>
          <Button
            variant="ghost"
            size="sm"
            className="text-xs h-7 text-muted-foreground hover:text-foreground"
          >
            <CheckCheck className="h-3.5 w-3.5 ml-1" />
            خواندن همه
          </Button>
        </div>

        <div className="max-h-80 overflow-y-auto bg-card">
          {MOCK_NOTIFICATIONS.map((notif) => (
            <div
              key={notif.id}
              className={cn(
                "flex gap-3 px-4 py-3 hover:bg-brand-50/40 transition-colors cursor-pointer border-b border-border/40 last:border-b-0",
                !notif.isRead && "bg-primary/[0.03]"
              )}
            >
              <div
                className={cn(
                  "w-9 h-9 rounded-xl flex items-center justify-center shrink-0",
                  notif.bgColor
                )}
              >
                <notif.icon className={cn("h-4 w-4", notif.color)} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2">
                  <p className="text-xs font-bold leading-tight text-foreground">
                    {notif.title}
                  </p>
                  {!notif.isRead && (
                    <span className="w-1.5 h-1.5 rounded-full bg-primary shrink-0 mt-1" />
                  )}
                </div>
                <p className="text-[11px] text-muted-foreground mt-1 leading-relaxed">
                  {notif.description}
                </p>
                <p className="text-[10px] text-muted-foreground/70 mt-1">
                  {notif.time}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t border-border/60 p-2 bg-primary/5">
          <Button
            variant="ghost"
            className="w-full text-xs h-8 text-primary hover:text-primary hover:bg-primary/10"
          >
            مشاهده همه اعلان‌ها
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}